module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/btn_2_pc_a094602cddae45230ae4a48846d0d8e3.png";